export default "__VITE_ASSET__CgJK5x$$__"